(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('main-header', class extends baseComponent.default {
    elements = {
      nav: 'main-nav'
    };
    
    render() {
      this.querySelectorAll('a[class*="main-header-toolbar-link"]').forEach((link) => {
        if (link.getAttribute('aria-label')) return;
        const text = link.querySelector('[class*="main-header-toolbar-link-text"]')?.textContent.trim();
        if (text) link.setAttribute('aria-label', text);
      });

      this.on('stickyMainHeader', (e, { sticky }) => {
        if(sticky) {
          this.classList.add('@sticky');
          document.body.style.setProperty('--sticky-header-offset', `${this.$nav.offsetHeight}px`);
        } else {
          this.classList.remove('@sticky');
          document.body.style.setProperty('--sticky-header-offset', '0');
        }
      })
    };
  });
})();